import { z } from './utils/zod.js';
import { dataResponse } from './utils/response-templates.js';
export const documentPagesDtoSchema = z.object({
    pageCount: z.number().int(),
    pages: z.array(z.object({
        index: z.number().int().openapi({ description: '0-based page index' }),
        width: z.number().openapi({ description: 'Visual width in PDF points, rotation applied' }),
        height: z.number().openapi({ description: 'Visual height in PDF points, rotation applied' }),
    })),
});
export const documentPagesResponseSchema = dataResponse(documentPagesDtoSchema);
export const documentDownloadLinkDtoSchema = z.object({
    url: z.string(),
    expiresAt: z.string().datetime(),
});
export const documentDownloadLinkResponseSchema = dataResponse(documentDownloadLinkDtoSchema);
export const documentTextRequestSchema = z.object({
    pages: z
        .array(z.number().int().min(0))
        .max(50)
        .optional()
        .openapi({ description: '0-based page indexes to read; all pages when omitted' }),
});
export const documentTextDtoSchema = z.object({
    pageCount: z.number().int(),
    pages: z.array(z.object({
        index: z.number().int(),
        text: z.string(),
    })),
    truncated: z.boolean(),
});
export const documentTextResponseSchema = dataResponse(documentTextDtoSchema);
